/**
 * The /accounting page's last conclusive "has access" answer, kept for the next hard load of this
 * browser: an entitled customer's reload then sends the overview's reads at once instead of after
 * the bootstrap (`features/accounting/lib/overview-prefetch.ts`). Only the user id is stored, never
 * a token; another user never matches it, a "no access" answer removes it, and sign-out removes it
 * by name (`auth/browser-session-boundary.ts`), whether or not the accounting modules ever loaded.
 *
 * Imports nothing, so the sign-out boundary can depend on it.
 */
export const ACCOUNTING_ACCESS_HINT_STORAGE_KEY = 'nt.accountingAccess'

export function forgetAccountingAccess(): void {
  try {
    window.localStorage.removeItem(ACCOUNTING_ACCESS_HINT_STORAGE_KEY)
  } catch {
    // Storage unavailable: there is nothing to forget.
  }
}

export function rememberAccountingAccess(userId: string, hasAccess: boolean): void {
  if (!hasAccess) return forgetAccountingAccess()
  try {
    window.localStorage.setItem(ACCOUNTING_ACCESS_HINT_STORAGE_KEY, userId)
  } catch {
    // Storage unavailable: the next hard load waits for the bootstrap instead.
  }
}

export function rememberedAccountingAccess(userId: string): boolean {
  try {
    return window.localStorage.getItem(ACCOUNTING_ACCESS_HINT_STORAGE_KEY) === userId
  } catch {
    return false
  }
}
